import { useEffect, useState } from "react";
import {
  Popconfirm,
  Space,
  Typography,
  Col,
  Input,
  Row,
  Select,
  notification,
} from "antd";
const { Search } = Input;
import { Content } from "antd/lib/layout/layout";
import { useDispatch, useSelector } from "react-redux";
import { PayloadType, ShareDataType } from "type";
import Table, { ColumnsType } from "antd/lib/table";
import queryString from "query-string";

import {
  getSharedDatas,
  setQuery,
  deleteSharedData,
} from "features/sharedDataSlice";
import { getTypeGroups } from "features/typeGroupSlice";

import _ from "lodash";
import CUSick from "./CUSick";
const { Title } = Typography;
function Sick() {
  const dispatch = useDispatch();
  const { query, sharedDatas } = useSelector(
    (state: any) => state.sharedDataReducer
  );

  const [searchText, setSearchText] = useState<any>(undefined);
  const [rowUpdate, setRowUpdate] = useState<any>(null);
  const [typeGroupId, setTypeGroupId] = useState<ShareDataType | "">("");

  const handleSearch = () => {
    dispatch(
      setQuery({
        ...query, // lấy lại những thuộc tính về query ban đầu được lấy từ useReducer
        codeOrName: !_.isEmpty(searchText) ? searchText : undefined,
        page: 1, //Trường lọc data là name và
        limit: 10,
      })
    );
  };

  //desc column
  const columns: ColumnsType<ShareDataType> = [
    {
      title: "Mã bệnh",
      dataIndex: "code",
      key: "code",
      align: "left",
      render(value) {
        return value;
      },
    },

    {
      title: "Tên bệnh",
      dataIndex: "name",
      key: "name",
      align: "left",
    },

    {
      title: "Ghi chú",
      dataIndex: "note",
      key: "note",
      align: "left",
    },

    {
      title: "Hành động",
      dataIndex: "action",
      key: "action",
      align: "center",
      render: (_, record: any) => {
        return (
          <Space>
            <a
              onClick={() => {
                setRowUpdate(record);
              }}
            >
              Sửa
            </a>
            <Popconfirm
              title={"Bạn có chắc chắn muốn xóa mục này không ?"}
              okText={"Có"}
              cancelText={"Không"}
              onConfirm={() => {
                const id = record?.id ?? "";
                if (id) {
                  const payload: PayloadType = {
                    params: id,
                    callback: {
                      success(values) {
                        notification.success({
                          message: "Xoá danh mục tên bệnh thành công!",
                        });
                        getListFood();
                      },
                      failed(errorMessage) {
                        notification.error({
                          message: "Xoá danh mục tên bệnh thất bại!",
                          description: errorMessage,
                        });
                      },
                    },
                  };
                  dispatch(deleteSharedData(payload));
                }
              }}
            >
              <a>Xoá</a>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];

  // Danh sách danh mục dùng chung
  const getTypeGroup = () => {
    const payload: PayloadType = {
      query: queryString.stringify({
        ...query,
        code: "SICK",
      }),
      callback: {
        success(dataTypeGroup) {
          setTypeGroupId(dataTypeGroup?.results[0]?.id);
          const payload: PayloadType = {
            query: queryString.stringify({
              ...query,
              typeGroupId: dataTypeGroup?.results[0]?.id,
            }),
            callback: {
              success() {},
              failed() {},
            },
          };
          dispatch(getSharedDatas(payload));
        },
        failed() {},
      },
    };
    dispatch(getTypeGroups(payload));
  };

  useEffect(() => {
    getTypeGroup();
  }, []);

  // Lấy loại của sản phẩm hiện tại

  const getListFood = () => {
    const payload: PayloadType = {
      query: queryString.stringify({
        ...query,
        typeGroupId: typeGroupId,
      }),
      callback: {
        success() {},
        failed() {},
      },
    };
    dispatch(getSharedDatas(payload));
  };

  useEffect(() => {
    if (typeGroupId !== "") {
      getListFood();
    }
  }, [query]);

  return (
    <Content className="custom-layout-content">
      <Row
        style={{
          height: "70px",
          marginBottom: "16px",
          lineHeight: "70px",
          padding: "16px 24px",
        }}
        className="background-content-layout"
      >
        <Col span={24}>
          <div className="space-between">
            <Title
              level={4}
              style={{
                marginBottom: "0px",
                height: "40px",
                lineHeight: "40px",
              }}
            >
              Danh mục tên bệnh
            </Title>
          </div>
        </Col>
      </Row>

      <Row>
        <Col span={6}>
          <div
            className="background-content-layout"
            style={{
              padding: "24px",
              marginRight: "8px",
            }}
          >
            <>
              <div className="space-between">
                <Title
                  level={4}
                  style={{
                    marginBottom: "20px",
                    height: "40px",
                    lineHeight: "40px",
                  }}
                >
                  {Object.keys(rowUpdate ?? {}).length === 0
                    ? "Thêm mới"
                    : "Cập nhật"}
                </Title>
              </div>
              <CUSick
                typeGroupId={typeGroupId}
                rowUpdate={rowUpdate}
                getListFood={getListFood}
                setRowUpdate={setRowUpdate}
              />
            </>
          </div>
        </Col>
        <Col span={18}>
          <div
            className=" background-content-layout"
            style={{ padding: "24px 16px", marginLeft: "8px" }}
          >
            <div
              className="space-between"
              style={{
                marginBottom: "20px",
                height: "40px",
                lineHeight: "40px",
                paddingLeft: "10px",
              }}
            >
              <Title level={5}>Danh sách</Title>
              <Space className="custom-placeholder-select">
                <Search
                  placeholder="Tìm kiếm theo mã bệnh "
                  onChange={(e) => setSearchText(e.target.value)}
                  onSearch={handleSearch}
                  style={{ width: 242 }}
                />
              </Space>
            </div>

            <Table
              style={{ marginLeft: "8px" }}
              className=""
              rowKey={"id"}
              columns={columns}
              dataSource={_.get(sharedDatas, "results", [])}
              pagination={{
                current: _.get(sharedDatas, "page", 1),
                pageSize: _.get(sharedDatas, "limit", 1),
                defaultPageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "50", "100"],
                total: _.get(sharedDatas, "totalResults", 1),
                showTotal: (total, range) => {
                  return `Có tất cả ${total} bản ghi`;
                },
                onChange(page, pageSize) {
                  dispatch(
                    setQuery({
                      ...query,
                      page: page,
                      limit: pageSize,
                    })
                  );
                },
              }}
            />
          </div>
        </Col>
      </Row>
    </Content>
  );
}

export default Sick;
